import { Box } from '@mui/material';

interface CalendlyLogoProps {
    readonly altText?: string;
    readonly height?: string | number;
    readonly width?: string | number;
}

function SignalLogo({ altText = 'Signal Logo', height = 30, width = 30 }: Readonly<CalendlyLogoProps>) {
    const basePath = process.env.EXPO_PUBLIC_IMAGE_SERVE_HOST;

    return (
        <Box
            alt={altText}
            component="img"
            src={`${basePath!}/logos/signal_logo.png`}
            sx={{
                height,
                objectFit: 'contain',
                width,
            }}
        />
    );
}

export default SignalLogo;
